<template>
  <div>
    <div class="user-banner banner">
      <h1 class="banner-title">个人中心</h1>
    </div>
    <v-card class="blog-container">
      <div>
        <span class="info-title">基本信息</span>
      </div>
      <v-row class="info-wrapper">
        <v-col md="3" cols="12">
          <button id="pick-avatar">
            <v-avatar size="140">
              <img :src="avatar" alt="" />
            </v-avatar>
          </button>
          <avatar-cropper @uploaded="uploadAvatar" @before-upload="handleBeforeUpload" trigger="#pick-avatar" upload-url="/api/users/avatar" :upload-headers="headers" />
        </v-col>
        <v-col md="7" cols="12">
          <v-text-field v-model="userInfo.nickname" label="昵称" placeholder="请输入您的昵称"/>
          <v-text-field v-model="userInfo.webSite" class="mt-7" label="个人网站" placeholder="http://你的网址"/>
          <v-text-field v-model="userInfo.intro" class="mt-7" label="简介" placeholder="介绍下自己吧"/>
          <div v-if="loginType !== 0" class="mt-7 binding">
            <v-text-field disabled v-model="email" label="邮箱号" placeholder="请绑定邮箱"/>
            <v-btn v-if="email" text small @click="openEmailModel">修改绑定</v-btn>
            <v-btn v-else text small @click="openEmailModel">绑定邮箱</v-btn>
          </div>
          <v-btn @click="handleUpdateUserInfo" outlined class="mt-5">修改</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import { getToken } from "@/utils/auth";
export default {
  components: { AvatarCropper },
  data: function() {
    return {
      userInfo: {
        nickname: this.$store.getters.nickname,
        intro: this.$store.getters.intro,
        webSite: this.$store.getters.webSite,
        loginType: this.$store.getters.loginType
      },
      headers: {
        Authorization: "Bearer " + getToken()
      },
      baseURL: process.env.VUE_APP_BASE_API,
    };
  },
  methods: {
    handleUpdateUserInfo() {
      this.$store.dispatch("UpdateUserInfo", this.userInfo).then(res => {});
      this.$toast({ type: "success", message: "修改成功" });
    },
    // 在上传前校验文件大小
    handleBeforeUpload(file) {
      const maxSize = 1 * 1024 * 1024 // 2MB，单位：字节

      if (file.size > maxSize) {
        this.$message.error('头像图片不能超过 1MB！')
        return false // 返回 false 阻止后续流程（裁剪+上传）
      }

      // 可选：校验文件类型
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('仅支持 JPG、PNG 格式的图片！')
        return false
      }

      return true // 允许继续
    },
    uploadAvatar(data) {
      if (data.flag) {
        this.$store.dispatch("UpdateAvatar", data.data);
        this.$toast({ type: "success", message: data.msg });
      } else {
        this.$toast({ type: "error", message: data.msg });
      }
    },
    openEmailModel() {
      this.$store.dispatch('app/setEmailFlag',true);
    }
  },
  computed: {
    email() {
      return this.$store.getters.email;
    },
    loginType() {
      return this.$store.getters.loginType;
    },
    avatar(){
      return this.$store.getters.avatar;
    }
  }
};
</script>

<style scoped>
.user-banner {
  background: #49b1f5 url(https://www.talk-ny.cn/article/setting.jpeg) no-repeat
    center center;
}
.info-title {
  font-size: 1.25rem;
  font-weight: bold;
}
.info-wrapper {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
#pick-avatar {
  outline: none;
}
.binding {
  display: flex;
  align-items: center;
}
</style>
